<div class="modal-container main-font">
  <div class="modal-content">
    <div class="title-container">
      <p class="mb-0 title-text">Gestisci remoto</p>
      <p class="mb-0 subtitle">
        Imposta i giorni di smart working per le settimane nei mesi futuri
      </p>
    </div>
    <div class="user-container">
      <img
        [src]="utilityService.getSanitizeUrl(user.path)"
        [alt]="user.first_name"
        class="user-image" />
      <div class="user-info-container">
        <p class="mb-0 text-name">{{ user.first_name }} {{ user.last_name }}</p>
        <p class="mb-0 role-text">{{ user.role }}</p>
      </div>
    </div>
    <div class="input-container w-100">
      <p class="mb-0 input-text">Giorni di smart working a settimana</p>
      <input nz-input type="number" class="w-100" [(ngModel)]="maxSmart" />
    </div>
  </div>
  <div class="modal-footer w-100">
    <button class="secondary-btn w-100" (click)="closeModal()">Annulla</button>
    <button class="primary-btn w-100" (click)="save()">Salva</button>
  </div>
</div>
